import Dot from '@/app/_components/ui/icons/Dot.svg';
import SmallStar from '@/app/_components/ui/icons/SmallStar.svg';
import Plus from '@/app/_components/ui/icons/Plus.svg';
import Minus from '@/app/_components/ui/icons/Minus.svg';
import Dislike from '@/app/_components/ui/icons/Dislike.svg';
import Like from '@/app/_components/ui/icons/Like.svg';
import QuestionWrap from '@/app/_components/ui/icons/QuestionWrap.svg';
import React, { useEffect, useState } from 'react';
import Image from 'next/image';
import moment from 'jalali-moment';
import More from '@/app/_components/ui/icons/More.svg';

export default function Comment({
  comment,
  reply = false,
  notShowingImage,
  openCommentsWithImage,
}) {
  const [commentDate, setCommentDate] = useState('');
  useEffect(() => {
    const jalali = moment(comment.created_at, 'YYYY-MM-DD')
      .locale('fa')
      .format('YYYY-MM-DD');
    setCommentDate(jalali);
  }, [comment]);

  return (
    <div
      className={`comment pl-2 w-full  flex  mt-2 ${
        !notShowingImage ? 'border' : ''
      } py-4 md:pt-2 border-light-gray-150 rounded-md md:border-t-0 md:border-x-0`}
    >
      <div className=" w-full p-2 md:p-0">
        <div className="commentAuthor flex items-center pt-2.5">
          <div className="avatar md:px-3 pl-3 md:flex-[0_0_75px] flex-[0_0_60px] flex items-center">
            {comment?.user_profile ? (
              <Image
                src={comment?.user_profile}
                width="50"
                height="50"
                className="rounded-full"
              />
            ) : (
              <Image
                src={`/images/avatar.svg`}
                width="50"
                height="50"
                alt="barghchi user comment avatar"
              />
            )}
          </div>
          <div className="flex-1">
            <div className="flex">
              <span className="md:text-sm text-xs font-bold">
                {comment?.anonymous == 1 ? 'کاربر برقچی' : comment.user_name}
              </span>
              <div className="h-[15px] border-l border-light-gray-300 pr-5"></div>

              <span className="md:text-xs text-tiny pr-5">{commentDate}</span>
              <Dot />
              <span className="md:text-xs text-tiny">
                {comment.buyer != 0 ? 'خریدار' : 'کاربر سایت'}
              </span>
            </div>
          </div>
        </div>
        <div
          className={` ${
            notShowingImage ? 'h-full overflow-y-auto custom-scroll-bar' : ''
          } commentContent mt-3 md:pr-[75px]`}
        >
          {comment.title ||
            (comment?.score > 0 && (
              <div className="commentTitle flex">
                <div className="flex ">
                  {comment?.score > 0 && (
                    <div className="bg-[#409b4f] text-[10px] rounded-md flex items-center px-1 ">
                      <SmallStar fill="#fff" />
                      <span className="text-white pr-1">{comment.score}</span>
                    </div>
                  )}

                  <div className=" text-xs md:text-sm text-dark-gray font-bold pr-2.5">
                    {comment.title}
                  </div>
                </div>
              </div>
            ))}

          <div className="text-sm leading-9 mt-4 font-light text-justify">
            {comment.content}
          </div>
          <div>
            {comment.strengths && (
              <div className="advantages mt-4 md:text-sm text-xs">
                <div className="font-bold">نقاط قوت</div>
                <div className="md:flex mt-3">
                  {comment.strengths.map((strength, index) => (
                    <div
                      key={index}
                      className="flex items-center md:pr-6 first:pr-0"
                    >
                      <Plus stroke="#4CAA77" />
                      <span className="pr-1">{strength}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {comment.weakness && (
              <div className="disadvantages mt-4 md:text-sm text-xs">
                <div className="font-bold">نقاط ضعف</div>
                <div className="md:flex mt-3">
                  {comment.weakness.map((weak, index) => (
                    <div
                      key={index}
                      className="flex items-center md:pr-6 first:pr-0"
                    >
                      <Minus stroke="#D71111" />
                      <span className="pr-1">{weak}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {comment.images &&
              comment.images.length > 0 &&
              !notShowingImage && (
                <div className="flex mt-4">
                  {comment.images.slice(0, 1).map((image, index) => (
                    <div
                      key={index}
                      className="ml-2 border border-light-gray-150 rounded-md cursor-pointer flex overflow-hidden"
                      onClick={() => openCommentsWithImage(comment.id)}
                    >
                      <Image src={image.full_path} width={70} height={70} />
                    </div>
                  ))}
                  {comment.images.length > 1 && (
                    <div
                      // key={index}
                      className="relative h-[70px] w-[70px] p-2 cursor-pointer border border-light-gray-300 rounded-md overflow-hidden"
                      onClick={() => openCommentsWithImage(comment.id)}
                    >
                      <div className="p-2">
                        <Image
                          src={comment.images[1].full_path}
                          width={70}
                          height={70}
                          placeholder="blur"
                          blurDataURL="/images/no-image.jpg"
                          className="blur"
                        />
                      </div>

                      <div className="absolute top-6 left-6">
                        <More />
                      </div>
                    </div>
                  )}
                </div>
              )}
            {!reply && (
              <div className="flex justify-between  mt-8">
                <div className="text-xs">
                  {comment.recommend == 0 ? (
                    <div className="flex">
                      <Dislike stroke="#fc2254" />
                      <span className="text-[#fc2254] pr-2">
                        خرید این محصول را توصیه نمیکنم
                      </span>
                    </div>
                  ) : comment.recommend == 1 ? (
                    <div className="flex">
                      <Like fill="#00A049" />
                      <span className="text-[#00A049] pr-2">
                        خرید این محصول را توصیه میکنم
                      </span>
                    </div>
                  ) : (
                    <div className="flex">
                      <QuestionWrap />
                      <span className="pr-2">
                        درباره خرید این محصول مطمئن نیستم
                      </span>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
